import { ApiResult, CrudService, isNotNullOrUndefinedOrEmpty } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { AtributoReceitaNcmEntity } from "@catalogo/models";
import { CONFIGURACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class NcmAtributoDataService extends CrudService<AtributoReceitaNcmEntity> {
    protected url: string;
    urlOriginal: string;
    
    constructor(
        @Inject(CONFIGURACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlOriginal = `${urlBase}/v1/ncm/<parentId>/atributoreceita`;
    }
    
    public withParentId(parentId: string) {
        this.url = this.urlOriginal.replace('<parentId>', parentId);
        return this;
    }
    
    public vigente(vigente: boolean) {
        this.url = `${this.url}?vigente=${vigente ? 'true' : 'false'}`
        return this;
    }
    
    public rfb(dataFimVigencia: string, modalidade: string) {
        let param = `modalidade=${modalidade}`;
        if(isNotNullOrUndefinedOrEmpty(dataFimVigencia)){
            const dataFormatada = new DatePipe('pt-BR').transform(dataFimVigencia, 'yyyy-MM-dd');
            param = `dataVigencia=${dataFormatada}&${param}`;
        }
        
        return this.httpClient.get<ApiResult<AtributoReceitaNcmEntity[]>>(`${this.url}/rfb?${param}`)
    }
    
    public detalhado() {
        this.url = `${this.url}/detalhes`
        return this;
    }
}
